<section class="container">
    <div class="b2b-format">
        <div class="b2b-format__content-text">
            <h3 class="b2b-format--title">
                {{ data.highlight_title }}
            </h3>
            <p class="b2b-format--subtitle" [innerHTML]="data.highlight_description"></p>
        </div>
        <div class="b2b-format__image">
            <img [src]="data.highlight_image?.url || 'assets/images/products.png'" [alt]="data.highlight_image?.alt || ''">
        </div>
    </div>
</section>